import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';

const icons = {
    DashboardCustomizeIcon
};

const insurerBillingDashboard = {
    id: 'group_insurer_dashboard',
    type: 'group',
    children: [
        {
            id: 'insurer_dashboard',
            title: 'Accounting Dashboard',
            type: 'item',
            url: '/insurer_dashboard',
            icon: icons.DashboardCustomizeIcon,
            breadcrumbs: false
        }
    ]
};

export default insurerBillingDashboard;